import { Clock, Receipt } from 'lucide-react';

import type { RouteListItem } from '@/types';

export const depositsSubNav: RouteListItem[] = [
  {
    path: '/pending-deposits/$id',
    icon: Clock,
    name: 'Pending Deposit',
  },
  {
    path: '/deposits/$id',
    icon: Receipt,
    name: 'Deposit',
  },
];
